import { FC } from 'react'

import { FeedItem } from '@forto-dev/phoenix-ui-core'

import { useLocalisation } from '@/utils/localisation'

import { ActivityFeedItemProps } from './types'

export const ActivityFeedItemSubscriptionRemoved: FC<ActivityFeedItemProps> = ({ item, status }) => {
  const { translate, translateDate } = useLocalisation()

  return (
    <FeedItem
      type="person"
      name={
        item.activity.customField.affectedSubscriberName ||
        item.activity.customField.affectedContact?.contactPerson ||
        'Service'
      }
      action={translate('feed.list.subscriptionRemoved.action')}
      date={translateDate('feed_date', item.activity.createdAt)}
      suffix={item.activity.actor.type === 'Service' ? translate('feed.suffix.automated') : undefined}
      status={status}
    >
      <a id={`feed-activity-${item.id}`} />
    </FeedItem>
  )
}
